import anodum from 'anodum';
import constants from '../constants';
import getLinkConfig from '../../link-editing/accessors/get-link-config';
import linkConstants from '../../link-editing/constants';
import isHomePage from '../../site/verifiers/is-home-page';

const { LINK_CONFIG_ATTRIBUTE } = linkConstants.common;

const isPageLink = (link, page) => {
  const linkConfig = getLinkConfig(link);

  if (isHomePage(page.path)) {
    return (
      linkConfig.linkType === linkConstants.linkTypes.PATH &&
      (linkConfig.reference === page.path || `/${page.locale}${linkConfig.reference}` === page.path)
    );
  }

  return linkConfig.linkType === linkConstants.linkTypes.PAGE && linkConfig.reference === page.id;
};

export function addPageNavigationItem(navigationHTML, navigationListSelector, page) {
  const navigationNode = anodum.parseElementFromString(navigationHTML);

  const navigationListNode = navigationNode.matches(navigationListSelector)
    ? navigationNode
    : navigationNode.querySelector(navigationListSelector);

  const itemNode = anodum.parseElementFromString(constants.navigation.NAVIGATION_ITEM_TEMPLATE);
  let linkConfig = {
    linkType: linkConstants.linkTypes.PAGE,
    reference: page.id,
  };

  if (isHomePage(page.path)) {
    linkConfig = {
      linkType: linkConstants.linkTypes.PATH,
      reference: page.path,
    };
  }

  const link = itemNode.querySelector(constants.navigation.LINK_SELECTOR);
  link.setAttribute(LINK_CONFIG_ATTRIBUTE, JSON.stringify(linkConfig));
  itemNode.querySelector(constants.navigation.TEXT_SELECTOR).textContent = page.name;

  navigationListNode.appendChild(itemNode);

  return navigationNode.outerHTML;
}

function getListItemNode({ parentNode }) {
  return anodum.isTag(parentNode, 'li') ? parentNode : getListItemNode(parentNode);
}

function nodeDepth(root, node, depth = 0) {
  return root !== node ? nodeDepth(root, node.parentNode, depth + 1) : depth;
}

export function removePageNavigationItem(navigationHTML, page) {
  const navigationNode = anodum.parseElementFromString(navigationHTML);

  const pageLinkNodes = Array.from(navigationNode.querySelectorAll('a')).filter((link) =>
    isPageLink(link, page)
  );

  pageLinkNodes.sort(
    (linkNode1, linkNode2) =>
      nodeDepth(navigationNode, linkNode2) - nodeDepth(navigationNode, linkNode1)
  );

  pageLinkNodes.forEach((pageLinkNode) => {
    const pageItemNode = getListItemNode(pageLinkNode);
    const isSubmenuItem = pageItemNode.classList.contains(constants.navigation.SUBMENU_ITEM_CLASS);
    const isOneOnlyChild = pageItemNode.matches(':only-child');
    const ownSubmenu = pageItemNode.querySelector(constants.navigation.SUBMENU_SELECTOR);

    if (ownSubmenu) {
      if (!isSubmenuItem) {
        Array.from(ownSubmenu.children).forEach((child) => {
          child.classList.remove(constants.navigation.SUBMENU_ITEM_CLASS);
          child.classList.add(constants.navigation.MENU_ITEM_CLASS);
        });
      }

      pageItemNode.replaceWith(...ownSubmenu.children);
    } else if (isOneOnlyChild && isSubmenuItem) {
      const parentItemNode = getListItemNode(pageItemNode);
      const parentLinkNode = parentItemNode.querySelector('a');

      while (parentItemNode.firstChild) {
        parentItemNode.removeChild(parentItemNode.firstChild);
      }

      parentItemNode.appendChild(parentLinkNode);
    } else {
      pageItemNode.remove();
    }
  });

  return navigationNode.outerHTML;
}

export function updatePageNavigationItem(navigationHTML, prevPage, page) {
  const navigationNode = anodum.parseElementFromString(navigationHTML);

  const pageLinkNode = Array.from(navigationNode.querySelectorAll('a')).find((link) =>
    isPageLink(link, prevPage)
  );

  const pageItemNode = getListItemNode(pageLinkNode);
  const pageTextNode = pageItemNode.querySelector(constants.navigation.TEXT_SELECTOR);
  let linkConfig = {
    linkType: linkConstants.linkTypes.PAGE,
    reference: page.id,
  };

  if (isHomePage(page.path)) {
    linkConfig = {
      linkType: linkConstants.linkTypes.PATH,
      reference: page.path,
    };
  }

  pageLinkNode.setAttribute(LINK_CONFIG_ATTRIBUTE, JSON.stringify(linkConfig));

  if (pageTextNode.innerText === prevPage.name) {
    pageTextNode.innerText = page.name;
  }

  return navigationNode.outerHTML;
}
